import createHistory from "history/createBrowserHistory";
import React from "react";
import {
  HashRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";

import Dashboard from "modules/dashboard/Dashboard";
import PushApp from "modules/exams/push-app/push-app";
import Login from "modules/authentication/login";
import AddQuestion from "modules/dashboard/AddQuestion";
import CopyExam from "modules/exams/copy-exam/copy-exam";
import ExamsInfo from "modules/exams/exams-info/exams-info";
import ForgotPassword from "modules/authentication/forgot";
import { TakeExam } from "modules/exams/take-exam/takeexam";
import { RouteWithSubRoutes } from "modules/service/common";
import QuestionBank from "modules/question-bank/QuestionBank";
import UploadQuestion from "modules/dashboard/UploadQuestion";
import CreateExam from "modules/exams/create-exam/create-exam";
import BaseApp from "modules/platform-components/base-app/BaseApp";
import Administration from "modules/administration/administration";
import { getUserDetails } from "modules/platform-components/utils/shared-data.service";
import ChangePassword from "modules/authentication/change-password";
import Classes from "modules/classes";
import ZoomMeeting from "modules/zoom";
import WowzaMeeting from "modules/wowza";
import FeedbackDashboard from "modules/feedback/FeedbackDashboard";
import Qb from "modules/qb/qb";
import Tests from "modules/tests/tests";
import Users from "modules/userManagement/users/Users";
import Roles from "modules/userManagement/roles/Roles";
import AIConfig from "modules/administration/ai-config/AIConfig";
import LLMPrompts from "modules/administration/llm-prompts/LLMPrompts";
import AnswerConflicts from "modules/answer-conflicts/AnswerConflicts";
import ClassificationConflicts from "modules/classification-conflicts/ClassificationConflicts";
import RephrasedQuestions from "modules/rephrased-questions/RephrasedQuestions";
import QuestionVariations from "modules/question-variations/QuestionVariations";
import TeamPerformance from "modules/team-performance/TeamPerformance";
import TestUploadList from "modules/test-upload/TestUploadList";
import TestUploadReview from "modules/test-upload/TestUploadReview";
import Forbidden403 from "modules/platform-components/forbidden/Forbidden403";
import PermissionRoute from "modules/platform-components/utils/PermissionRoute";

const history = createHistory();

const isAuthenticated = () => {
  return getUserDetails().email ? true : false;
};

const PrivateRoute = (Component: any) => (props: any) => (
  isAuthenticated() ? <Component {...props} /> : <Redirect to="/login" />
);

const PublicRoute = (Component: any) => (props: any) => (
  isAuthenticated() ? <Redirect to="/app/dashboard" /> : <Component {...props} />
);

export const permissions: any = {
  "Question Creator": {
    addQuestion: true,
    editQuestion: true,
    deleteQuestion: true,
    sendForApproval: true,
  },
  "Question Approver": {
    approve: true,
    addQuestion: true,
    correctionNeeded: true,
    rejected: true,
    deleteQuestion: true,
    sendForApproval: true,
  },
  "Exam Creator": {
    createExam: true,
    copyExam: true,
    sendForApproval: true,
    editExam: true,
    deleteExam: true,
    download: true,
  },
  "Exam Approver": {
    approve: true,
    download: true,
  },
};
export const examineeRoutes = [
  {
    path: "/app/dashboard",
    component: PrivateRoute(Dashboard),
    exact: true,
    name: "Dashboard",
  },
  {
    path: "/app/exams/examsInfo",
    component: PrivateRoute(ExamsInfo),
    exact: true,
    name: "Exams",
    cssClass: "fa fa-book-open",
  },
  {
    path: "/app/exams/createExam",
    component: PrivateRoute(CreateExam),
    displayNone: true,
  },
  {
    path: "/app/exams/copyExam/:id/:examname",
    component: PrivateRoute(CopyExam),
    name: "Copy Exam",
    displayNone: true,
  },
  {
    path: "/app/exams/pushToApp/:id/:batchid",
    component: PrivateRoute(PushApp),
    name: "Push To App",
    displayNone: true,
  },
  {
    path: "/app/exams/examDetailView/:examid",
    component: PrivateRoute(CreateExam),
    displayNone: true,
    exact: true,
    name: "Exam Detail View",
  },
  {
    path: "/app/exams/takeorviewexam",
    component: PrivateRoute(TakeExam),
    displayNone: true,
    exact: true,
    name: "Take & View Exam",
  },
];
export const questionCreatorRoutes = [
  {
    path: "/app/dashboard",
    component: PrivateRoute(Dashboard),
    exact: true,
    name: "Dashboard",
  },
  {
    path: "/app/question/:id",
    component: PrivateRoute(AddQuestion),
    displayNone: true,
    exact: true,
    name: "Add Question",
  },
  {
    path: "/app/file/:type/:id",
    component: PrivateRoute(UploadQuestion),
    displayNone: true,
    exact: true,
    name: "Upload Question",
  },
  // {
  //   path: "/app/questionbank",
  //   component: isAuthenticated() ? QuestionBank : <Redirect to="/login" />,
  //   name: "Question Bank",
  //   cssClass: "fa fa-file-alt",
  // },
  // {
  //   path: "/app/feedback",
  //   component: isAuthenticated() ? Feedback : <Redirect to="/login" />,
  //   name: "Student Feedback",
  //   cssClass: "fa fa-file-alt",
  //   isApp: true,
  // },
  // {
  //   path: "/app/tests",
  //   component: isAuthenticated() ? Tests : <Redirect to="/login" />,
  //   name: "Tests",
  //   cssClass: "fa fa-file-alt",
  //   isApp: true,
  // },
  {
    path: "/app/qb",
    component: PrivateRoute(Qb),
    name: "Question Bank",
    cssClass: "fa fa-database",
    isApp: true,
  },
];
export const questionApproverRoutes = [
  {
    path: "/app/dashboard",
    component: PrivateRoute(Dashboard),
    exact: true,
    name: "Dashboard",
  },
  {
    path: "/app/questionbank",
    component: PrivateRoute(QuestionBank),
    name: "Question Repo",
    cssClass: "fa fa-archive",
  },
  // {
  //   path: "/app/feedback",
  //   component: isAuthenticated() ? Feedback : <Redirect to="/login" />,
  //   name: "Student Feedback",
  //   cssClass: "fa fa-file-alt",
  //   isApp: true,
  // },
  // {
  //   path: "/app/tests",
  //   component: isAuthenticated() ? Tests : <Redirect to="/login" />,
  //   name: "Tests",
  //   cssClass: "fa fa-file-alt",
  //   isApp: true,
  // },
  {
    path: "/app/qb",
    component: PrivateRoute(Qb),
    name: "Question Bank",
    cssClass: "fa fa-archive",
    isApp: true,
  },
  {
    path: "/app/question/:id",
    component: PrivateRoute(AddQuestion),
    displayNone: true,
    exact: true,
    name: "Add Question",
  },
  {
    path: "/app/file/:type/:id",
    component: PrivateRoute(UploadQuestion),
    displayNone: true,
    exact: true,
    name: "Upload Question",
  },
];
export const examCreator = [
  {
    path: "/app/exams/examsInfo",
    component: PrivateRoute(ExamsInfo),
    exact: true,
    name: "Exams",
    cssClass: "fa fa-book-open",
  },
  {
    path: "/app/exams/createExam",
    component: PrivateRoute(CreateExam),
    displayNone: true,
  },
  {
    path: "/app/exams/copyExam/:id/:examname",
    component: PrivateRoute(CopyExam),
    name: "Copy Exam",
    displayNone: true,
  },
  {
    path: "/app/exams/pushToApp/:id/:batchid",
    component: PrivateRoute(PushApp),
    name: "Push To App",
    displayNone: true,
  },
  {
    path: "/app/exams/examDetailView/:examid",
    component: PrivateRoute(CreateExam),
    displayNone: true,
    exact: true,
    name: "Exam Detail View",
  },
];

export const FacultyRoute = [
  {
    path: "/app/classes",
    component: PrivateRoute(Classes),
    name: "Classes",
    accessLevel: ["Faculty"],
  },
];

export const routes = [
  {
    path: "/",
    component: PublicRoute(Login),
    exact: true,
  },
  {
    path: "/login",
    component: PublicRoute(Login),
  },
  {
    path: "/app",
    component: PrivateRoute(BaseApp),
    routes: [
      {
        path: "/app/dashboard",
        component: PermissionRoute(Dashboard, "Dashboard"),
        exact: true,
        name: "Dashboard",
        cssClass: "fa fa-tachometer-alt",
        category: "Dashboard",
      },
      {
        path: "/app/questionbank",
        component: PermissionRoute(QuestionBank, "Question Repo"),
        name: "Question Repo",
        cssClass: "fa fa-archive",
        category: "Question Repo",
      },
      {
        path: "/app/feedback",
        component: PermissionRoute(FeedbackDashboard, "Students Feedback"),
        name: "Student Feedback",
        cssClass: "fa fa-comments",
        category: "Students Feedback",
        isApp: true,
      },
      {
        path: "/app/tests",
        component: PermissionRoute(Tests, "Test"),
        name: "Tests",
        cssClass: "fa fa-file-signature",
        category: "Test",
        isApp: true,
      },
      {
        path: "/app/qb",
        component: PermissionRoute(Qb, "Question Bank"),
        name: "Question Bank",
        cssClass: "fa fa-database",
        category: "Question Bank",
        isApp: true,
      },
      {
        path: "/app/exams/examsInfo",
        component: PrivateRoute(ExamsInfo),
        exact: true,
        name: "Exams",
        cssClass: "fa fa-book-open",
        category: "Exams"
      },
      {
        path: "/app/exams/createExam",
        component: PrivateRoute(CreateExam),
        displayNone: true,
        category: "Exams",
      },
      {
        path: "/app/exams/copyExam/:id/:examname",
        component: PrivateRoute(CopyExam),
        name: "Copy Exam",
        displayNone: true,
        category: "Exams",
      },
      {
        path: "/app/exams/pushToApp/:id/:batchid",
        component: PrivateRoute(PushApp),
        name: "Push To App",
        displayNone: true,
        category: "Exams",
      },
      {
        path: "/app/exams/examDetailView/:examid",
        component: PrivateRoute(CreateExam),
        displayNone: true,
        exact: true,
        name: "Exam Detail View",
        category: "Exams",
      },
      {
        path: "/app/question/:id",
        component: PrivateRoute(AddQuestion),
        displayNone: true,
        exact: true,
        name: "Add Question",
      },
      {
        path: "/app/file/:type/:id",
        component: PrivateRoute(UploadQuestion),
        displayNone: true,
        exact: true,
        name: "Upload Question",
      },
      {
        path: "/app/adminPanel",
        component: PermissionRoute(Administration, "Admin Panel"),
        displayNone: true,
        exact: true,
        name: "Admin",
        category: "Admin Panel",
      },
      {
        path: "/app/change-password",
        component: PrivateRoute(ChangePassword),
        displayNone: true,
        exact: true,
        name: "change",
      },
      {
        path: "/app/forbidden",
        component: PrivateRoute(Forbidden403),
        displayNone: true,
        exact: true,
        name: "Forbidden",
      },
      {
        path: "/app/usersList",
        component: PermissionRoute(Users, "Users"),
        name: "Users",
        exact: true,
        cssClass: "fa fa-user-friends",
        category: "Users",
      },
      {
        path: "/app/roles",
        component: PermissionRoute(Roles, "Roles"),
        name: "Roles",
        exact: true,
        cssClass: "fa fa-user-shield",
        category: "Roles",
      },
      {
        path: "/app/answer-conflicts",
        component: PermissionRoute(AnswerConflicts, "QA", "Answer Conflicts"),
        name: "Answer Conflicts",
        exact: true,
        cssClass: "fa fa-exclamation-triangle",
        category: "QA",
      },
      {
        path: "/app/classification-conflicts",
        component: PermissionRoute(ClassificationConflicts, "QA", "Classification Review"),
        name: "Classification Review",
        exact: true,
        cssClass: "fa fa-tags",
        category: "QA",
      },
      {
        path: "/app/rephrased-questions",
        component: PermissionRoute(RephrasedQuestions, "QA", "Rephrased Questions"),
        name: "Rephrased Questions",
        exact: true,
        cssClass: "fa fa-clone",
        category: "QA",
      },
      {
        path: "/app/question-variations",
        component: PermissionRoute(QuestionVariations, "QA", "Question Variations"),
        name: "Question Variations",
        exact: true,
        cssClass: "fa fa-random",
        category: "QA",
      },
      {
        path: "/app/team-performance",
        component: PermissionRoute(TeamPerformance, "QA", "Team Performance"),
        name: "Team Performance",
        exact: true,
        cssClass: "fa fa-chart-bar",
        category: "QA",
      },
      {
        path: "/app/test-upload",
        component: PermissionRoute(TestUploadList, "Test Upload", "Upload Test"),
        name: "Test Upload",
        exact: true,
        cssClass: "fa fa-file-upload",
        category: "Test Upload",
        isApp: true,
      },
      {
        path: "/app/test-upload/review/:jobId",
        component: PermissionRoute(TestUploadReview, "Test Upload", "Review & Approve"),
        name: "Review Test Upload",
        displayNone: true,
        exact: true,
        category: "Test Upload",
        isApp: true,
      },
      {
        path: "/app/administration/ai-config",
        component: PermissionRoute(AIConfig, "Administration", "AI Config"),
        name: "AI Config",
        exact: true,
        cssClass: "fa fa-robot",
        category: "Administration",
      },
      {
        path: "/app/administration/llm-prompts",
        component: PermissionRoute(LLMPrompts, "Administration", "LLM Prompts"),
        name: "LLM Prompts",
        exact: true,
        cssClass: "fa fa-scroll",
        category: "Administration",
      },
    ],
  },
  {
    path: "/forgot-password",
    component: PublicRoute(ForgotPassword),
  },
  {
    path: "/start-class/:id",
    component: PrivateRoute(ZoomMeeting),
  },
  {
    path: "/wowza/start-class/:id",
    component: PrivateRoute(WowzaMeeting),
  },
];

export const AppRoutes = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          {isAuthenticated() ? <Redirect to="/app/dashboard" /> : <Redirect to="/login" />}
        </Route>
        {routes.map((route) => {
          return <RouteWithSubRoutes key={route.path} {...route} />;
        })}
      </Switch>
    </Router>
  );
};
